import { Directive, HostListener } from '@angular/core';
import { HasUnsavedChanges } from './has-unsaved-changes';

@Directive()
/* This is an abstract class that will be extended by components */
export abstract class MmuCanDeactivateComponent implements HasUnsavedChanges {
  @HostListener('window:beforeunload', ['$event'])
  protected onPageUnload($event: BeforeUnloadEvent): void {
    if (this.hasUnsavedChanges()) {
      $event.returnValue = true;
    }
  }

  abstract hasUnsavedChanges(): boolean;
}
